<template>
    <card-list-item @action="$emit('action')" :class="{'active': active}">
        <template v-slot:icon>
            <i class="far fa-fw" :class="icon"></i>
        </template>

        <template v-slot:content>
            <div class="title">
                <span v-if="title">{{title}}</span>
                <span v-if="subtitle" class="subtitle"><br>{{subtitle}}</span>
                <span v-if="alert" class="alert"><br><i class="far fa-exclamation-triangle pr-2"></i>{{alert}}</span>
            </div>
        </template>

        <template v-slot:badge>
            <div class="stats">
                <span v-if="badge" class="stat"><i class="far fa-fw" :class="icon"></i>{{badge}}</span>
                <span v-if="amount" class="amount">{{amount}}</span>
                <span v-if="date" class="date"><br>{{date}}</span>
                <span v-if="tag">
                    <div class="tag"><i class="far fa-tag pr-2"></i>{{tag}}</div>
                </span>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import CardListItem from "./common/CardListItem";

    export default {
        name: 'menuListItem',
        components: {CardListItem},
        props: {
            card: {
                required: true
            },
            active: {
                type: Boolean,
                default: false
            },
            title: {
                type: String
            },

            subtitle: {
                type: String
            },

            icon: {
                type: String
            },

            badge: {
                type: String
            },

            alert: {
                type: String
            },

            amount: {
                type: String
            },

            date: {
                type: String
            },

            tag: {
                type: String
            }
        },
        data: function () {
            return {
                details: false,
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../assets/variables';

    li {
        padding: 0.6rem 0;

        .title {
            font-size: 0.95rem;
            font-weight: bold;
        }

        .subtitle {
            font-size: 12px;
            font-weight: lighter;
            margin-top: -15px;
        }

        .alert {
            font-size: 12px;
            font-weight: bold;
            margin-top: -15px;
            color: #721c24;
        }

        .tag {
            font-size: 10px;
            color: #ffffff;
            background-color: #8495af;
            border: 1px solid #8495af;
            border-radius: 5px;
            margin-top: 3px;
            padding: 3px;
            text-align: center;
        }

        .amount {
            font-size: 0.95rem;
        }

        .date {
            font-size: 10px;
        }

        .stats {
            margin-top: 0.1rem;
            font-size: 0.7rem;
            display: block;

            .stat {
                margin-left: 0.5rem;

                i {
                    margin-right: 0.2rem;
                    font-size: 0.65rem;
                }
            }
        }
    }
</style>
